var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:none;opacity:0;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.017.146a.5.5,0,0,0-.708,0L7.088,6.384.854.146A.5.5,0,0,0,.146.854l6.575,6.58a.488.488,0,0,0,.354.146.509.509,0,0,0,.354-.146L14,.854A.491.491,0,0,0,14.017.146Z",
    transform: "translate(7.581) rotate(90)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-268 -508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(265 524) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.235 0.958)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.017.146a.5.5,0,0,0-.708,0L7.088,6.384.854.146A.5.5,0,0,0,.146.854l6.575,6.58a.488.488,0,0,0,.354.146.509.509,0,0,0,.354-.146L14,.854A.491.491,0,0,0,14.017.146Z",
    transform: "translate(7.581) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.187 -0.911)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16.002,
    height: 16.002
  })))))), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 16,
    height: 16,
    transform: "translate(268 508)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.a90ce2c409b34e83b82988e95c9f7b49.svg";
export { ForwardRef as ReactComponent };